import React, { JSX } from 'react';
import {
  Box,
  Button,
  Header,
  Modal,
  SpaceBetween,
  TextContent,
} from '@amzn/awsui-components-react';
import { useIntl } from 'react-intl';
import restrictICantFlowMessages from '../i18n/restrictICantFlow.messages';

const RestrictIcantFlowComponent = (): JSX.Element => {
  const [visible, setVisible] = React.useState(true);
  const { formatMessage } = useIntl();
  if (visible) {
    return (
      <Modal
        onDismiss={() => setVisible(false)}
        visible={visible}
        header={
          <Header>
            <Header>{formatMessage(restrictICantFlowMessages.header)}</Header>
          </Header>
        }
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button
                variant="primary"
                onClick={(e) => {
                  e.preventDefault();
                  setVisible(false);
                }}
              >
                Okay
              </Button>
            </SpaceBetween>
          </Box>
        }
      >
        <TextContent>
          {formatMessage(restrictICantFlowMessages.bodyConent)}
        </TextContent>
      </Modal>
    );
  } else {
    return <></>;
  }
};

export default RestrictIcantFlowComponent;
